export const MOCK_ASSIGNED_EQUIPMENT = [
  { id: 1, name: "Boston Whaler 600", assetNumber: "-", category: "Boats and Vehicles" },
  { id: 2, name: "Solo Explorer", assetNumber: "002", category: "Boats and Vehicles" },
  { id: 3, name: "Nautical Dreamer", assetNumber: "001", category: "Boats and Vehicles" }
]

export const MOCK_AVAILABLE_EQUIPMENT = [
  { id: 4, name: "Boston Whaler 600", assetNumber: "-", category: "Boats and Vehicles" },
  { id: 5, name: "Solo Explorer", assetNumber: "002", category: "Boats and Vehicles" },
  { id: 6, name: "Nautical Dreamer", assetNumber: "001", category: "Boats and Vehicles" },
  { id: 7, name: "Seaside Explorer", assetNumber: "034", category: "Boats and Vehicles" },
  { id: 8, name: "Wave Rider", assetNumber: "023", category: "Fishing Gear" }
]

export const MOCK_CATEGORIES = ["Boats and Vehicles", "Fishing Gear"]

export const CATEGORY_OPTIONS = [
  { value: "all", label: "All Categories" },
  { value: "Boats and Vehicles", label: "Boats and Vehicles" },
  { value: "Fishing Gear", label: "Fishing Gear" }
]
